import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppBar, Avatar, CardHeader, Button, Toolbar, IconButton, TextField, Typography, CircularProgress, Dialog } from '@material-ui/core'
import { index, change } from '../../../store/actions/menor.action'
import { FaCheck, FaSearch } from 'react-icons/fa'
import { FcFilingCabinet } from 'react-icons/fc'
import { MdKeyboardBackspace } from 'react-icons/md'
import { IoLogoWhatsapp, IoMdSettings } from "react-icons/io"
import { changeScreen, changeScreenB } from '../../../store/actions/navigation.action'
import Fullname from '../../components/Fullname'
import Detail from './detail'

export default function MenorCota(props) {
    const dispatch = useDispatch()
    const campaign_id = (props.uid) ? props.uid : null;
    const { cotas } = useSelector(state => state.menorReducer)

    const date = new Date();
    const dateInit = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T00:00'
    const dateEnd = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T23:59'

    const [isLoading, setLoading] = React.useState(false)
    
    const [dateInitial, setDateInitial] = React.useState(dateInit);
    const [dateFinal, setDateFinal] = React.useState(dateEnd);

    const [type, setType] = React.useState('menor')
    const [qtd, setQtd] = React.useState(1)

    const [detail, setDetail] = React.useState({
        open: false,
        campaign_id: null,
        number: null
    })

    React.useEffect(() => {
        return () => {
            dispatch(change('clear'))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const filter = () => {
        setLoading(true)

        dispatch(index(campaign_id, new Date(dateInitial), new Date(dateFinal), type, qtd)).then(() => {
            setLoading(false)
        })
    }

    const _detail = (campaign_id, number) => {
        setDetail({
            open: true,
            campaign_id: campaign_id,
            number: number
        })
    }

    const handlePage = (page) => {
        dispatch(changeScreenB({
            open: true,
            type: page,
            props: {
                campaign_id: campaign_id
            }
        }))
    }

    return (
        <>
        <div className="app-bar">
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6" >
                        Maior ou Menor
                    </Typography>

                    <Button 
                        variant="contained" 
                        size="small" 
                        onClick={() => filter()}
                        color="inherit" 
                        className="ms-auto btn-app-bar"
                        startIcon={<FaSearch />}
                        
                    >
                        Pesquisar
                    </Button>
                </Toolbar>
            </AppBar>

            <Dialog
                open={detail.open}
                maxWidth="sm"
                style={{width: '100%'}}
                onClose={() => setDetail({ campaign_id: null, number: null , open: false })}
                className="center"
            >   
                <Detail campaign_id={detail.campaign_id} number={detail.number} onClose={() => setDetail({ campaign_id: null, number: null , open: false})}/>
            </Dialog>

            <div className="card p-3 mt-3 mb-2 bs-bg">

                <div className="row mb-3">
                    <div className="col-3">
                        <Button 
                            fullWidth 
                            className={"bs-bg-invert bs-color-b "+ (type === 'menor' && 'btn-checked')}
                            variant="contained" 
                            color="primary" 
                            size="small"
                            onClick={() => setType('menor')}
                        >
                            MENOR
                        </Button>
                    </div>

                    <div className="col-3">
                        <Button 
                            fullWidth 
                            className={"bs-bg-invert bs-color-b "+ (type === 'maior' && 'btn-checked')}
                            variant="contained" 
                            color="primary" 
                            size="small"
                            onClick={() => setType('maior')}
                        >
                            MAIOR
                        </Button>
                    </div>

                    <div className="col-6 d-flex justify-content-end">
                        <Button
                            className={"bs-bg-invert bs-color-b icon-button"}
                            variant="contained" 
                            color="primary"
                            onClick={() => handlePage('menor-gestao')}
                            startIcon={<IoMdSettings />}
                        >
                        </Button>
                    </div>
                </div>
                
                <div className="row mb-3 mt-2">
                    <div className="col-6">
                        <div className="date">
                            <label className="label-date bs-color-b">
                                {(dateInitial) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(dateInitial))}&nbsp;&nbsp;&nbsp;
                                {(dateInitial) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(dateInitial))}    
                            </label>
                            <TextField
                                id="datetime-local"
                                label="Data Inicial"
                                type="datetime-local"
                                defaultValue={dateInitial}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={e => {
                                    if(e.target.value) {
                                        setDateInitial(e.target.value)
                                    } else {
                                        setDateInitial(dateInit)
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="date">
                            <label className="label-date bs-color-b">
                                {(dateFinal) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(dateFinal))}&nbsp;&nbsp;&nbsp;
                                {(dateFinal) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(dateFinal))}    
                            </label>
                            <TextField
                                id="datetime-local"
                                label="Data Final"
                                type="datetime-local"
                                defaultValue={dateFinal}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={e => {
                                    if(e.target.value) {
                                        setDateFinal(e.target.value)
                                    } else {
                                        setDateFinal(dateEnd)
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>

                <h6 className="bs-color-b mb-3">Quantidade</h6>

                <div className="row mb-3">
                    <div className="col">
                        <Button 
                            fullWidth 
                            className={"bs-bg-invert bs-color-b "+ (qtd === 1 && 'btn-checked')}
                            variant="contained" 
                            color="primary" 
                            size="small"
                            onClick={() => setQtd(1)}
                        >
                            1
                        </Button>
                    </div>

                    <div className="col">
                        <Button 
                            fullWidth 
                            className={"bs-bg-invert bs-color-b "+ (qtd === 3 && 'btn-checked')}
                            variant="contained" 
                            color="primary" 
                            size="small"
                            onClick={() => setQtd(3)}
                        >
                            3
                        </Button>
                    </div>

                    <div className="col">
                        <Button
                            fullWidth 
                            className={"bs-bg-invert bs-color-b "+ (qtd === 5 && 'btn-checked')}
                            variant="contained" 
                            color="primary" 
                            size="small"
                            onClick={() => setQtd(5)}
                        >
                            5
                        </Button>
                    </div>

                    <div className="col">
                        <Button 
                            fullWidth 
                            className={"bs-bg-invert bs-color-b "+ (qtd === 10 && 'btn-checked')}
                            variant="contained" 
                            color="primary" 
                            size="small"
                            onClick={() => setQtd(10)}
                        >
                            10
                        </Button>
                    </div>
                </div>
            </div>

            {(isLoading) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
                <div className="mt-3">
                    {(cotas.length < 1) &&
                        <div className="card card-body mt-3 bs-bg">
                            <div className="text-center mt-5 pt-5 mb-5 pb-5">
                                <FcFilingCabinet size="70" />
                                <h6 className="mt-4 text-muted bs-color">Nenhum registro encontrado</h6>
                            </div>
                        </div>
                    }

                    {(cotas.length > 0) &&
                        <>
                        {cotas.map((item, index) => (
                            <div className="card pointer bs-bg list-items" style={{border: '1px solid #eee'}} key={index}>
                                <CardHeader
                                    className="pb-2 pt-3"
                                    avatar={
                                        <Avatar className="avatar-item" onClick={() => _detail(campaign_id, item.number)}>
                                            <span className="fw-bold">{index + 1}</span>
                                        </Avatar> 
                                    }
                                    title={<h5 className="fw-semibold m-0 bs-color-b" onClick={() => _detail(campaign_id, item.number)}>{item.number}</h5>}
                                    subheader={
                                        <>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <span className="d-block pointer bs-color mt-1">{<Fullname fullName={item.user.name ? item.user.name.substring(0,25) : item.user.name} />}</span>
                                                <small className="bs-color" onClick={() => _detail(campaign_id, item.number)}>{new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(item.transaction.paid_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(item.transaction.paid_at))}</small>
                                            </div>
                                            <span className="me-2">
                                                <a href={'http://wa.me/55'+item.user.telefone} target="_blank" rel="noopener noreferrer">
                                                    <IoLogoWhatsapp color="#24d366" size={30}/>
                                                </a>
                                            </span>
                                        </div>
                                        </>
                                    } 
                                />
                            </div>
                        ))}
                        </>
                    }
                </div>
            }
        </div>
        </>
    )
}